import { cn } from "@/lib/utils";
import type * as React from "react";

type PageHeaderProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string;
};

/**
 * Standard page header for dashboard pages. Pure typography — no border, no
 * action slot. Per the dashboard convention, page-level action buttons live
 * at the top-right of the section/table they belong to, not here.
 */
export function PageHeader({ title, subtitle, className }: PageHeaderProps) {
  return (
    <div className={cn("space-y-1", className)}>
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
    </div>
  );
}
